import Row from 'react-bootstrap/Row';
import styled from 'styled-components';
import { DEFAULT_FONT_SIZE, LG_PADDING, SEMI_FONT_WEIGHT, SM_PADDING } from '../../components/Common/StyleElement';

export const UploadRow = styled(Row)`
    padding-bottom: ${LG_PADDING};
`

export const PreviewTitle = styled.div`
    font-size: ${DEFAULT_FONT_SIZE};
    font-weight: ${SEMI_FONT_WEIGHT};
    padding-bottom: ${SM_PADDING};
`